import { getStatistics } from '../api/getStatistics';
import { setGettatisticsAction } from '../action';

export const setGetStatistics = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getStatistics(params);
            dispatch(setGettatisticsAction(data));
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}